import React from 'react';

import RegisterForm from '../../components/RegisterForm/RegisterForm';
import GuestLayout from '../../components/Layouts/GuestLayout';
// import _s from './Register.less';

const RegisterPage = () => (
  <GuestLayout>
    <div
      style={{
        position: 'relative',
        width: '100%',
        height: '100vh',
        margin: 0,
        padding: 0,
        overflow: 'hidden'
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: 'url("/public/images/signup_bg.jpg")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          filter: 'blur(8px)',
          zIndex: 0
        }}
      ></div>

      <div
        style={{
          position: 'relative',
          zIndex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%'
        }}
      >
        <RegisterForm />
      </div>
    </div>
  </GuestLayout>
);

export default RegisterPage;
